<template lang="pug">
#modal.modal.fade(ref='modal' tabindex='-1', role='dialog', aria-labelledby='ModalViewer', aria-hidden='true' :class='classes')
    .modal-dialog.modal-dialog-centered.modal-lg(role='document')
        .modal-content
            .modal-body
                .modal-header.pl-sm-5.pr-sm-5.mt-3(v-if='modal.title')
                    h5 {{ modal.title }}
                button.closeModal.d-none.d-sm-block(type='button', data-dismiss='modal', aria-label='Close')
                  span(aria-hidden='true') ×
                // 16:9 aspect ratio
                .embed-responsive.embed-responsive-16by9(v-if='modal.type === MODAL.VIDEO')
                  iframe#video.embed-responsive-item(:src='modal.url', frameborder='0', allow='autoplay; encrypted-media', allowfullscreen='')
                .p.m-3.ml-sm-5.mr-sm-5(v-if='modal.type === MODAL.DIALOG') {{ modal.message }}
                img#image.img-fluid(v-if='modal.type === MODAL.IMAGE' :src='modal.url')
            .modal-footer.mr-sm-3.mb-sm-3(v-if='modal.close')
                button.btn.btn-secondary(type='button', data-dismiss='modal') {{ modal.close}}


</template>
<script>
import MODAL from '@/constants/modal-types'

export default {    
    data (){
        return {
            MODAL,
            modal: '',
            classes: '',
        }
    },
    created () {
        this.$bus.$on('show', (modal) => {
            this.modal = modal
           $('#modal').modal('show')
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue